import { Power2, TimelineMax, TweenMax } from "gsap";
import App from '../../../vendor_core/core/src/App';
import GameEvents from "../../../vendor_core/core/src/const/GameEvents";
import GameModel from "../../../vendor_core/core/src/model/GameModel";
import SpinModel from "../../../vendor_core/core/src/model/SpinModel";
import { OverlayType } from "../../../vendor_core/core/src/server/data/ISpinData";
import ReelReverseCascadeBehaviour from "../../../vendor_core/core/src/spinners/ReelReverseCascadeBehaviour";
import ConsoleUtil from '../../../vendor_core/core/src/utils/ConsoleUtil';
import { DefaultLayers } from "../../../vendor_core/core/src/utils/Layers";
import SoundController from "../../../vendor_core/core/src/utils/SoundController";
import ViewManager from "../../../vendor_core/core/src/utils/ViewManager";
import BBModel from '../model/BBModel';
import BBAnimationsHelper from '../utils/BBAnimationsHelper';
import BBReelGroup from "./BBReelGroup";
import BBReelSymbol from './BBSymbol';

export default class BBReelReverseCascadeBehaviour extends ReelReverseCascadeBehaviour {
    private fillRemainingDelay: number = 0.2;

    public symPool: BBReelSymbol[]

    private isStopPlayingg: boolean = false;

    protected fillExplodes(explodedItems: boolean[], wildsMovedToReel?: number[], wildsMovedFromReel?: number[]) {
        wildsMovedToReel.forEach((row, index) => row === 0 ? explodedItems[index] = false : null);
        wildsMovedFromReel.forEach((row, index) => row === 0 ? explodedItems[index] = true : null);


        this.cascadeTL.pause();
        // this.reel.sortSymbolsByY();
        this.inCascade = true;

        let index = this.startSymbolIndex;

        let totalDuration = 0;
        let powerOfBounce = 8;

        while (index >= 0 && index < this.reel.symbols.length) {
            powerOfBounce--
            let exploded = explodedItems[index];
            let sym = this.reel.symbols[index] as BBReelSymbol;

            // sym.visible = false;

            if (sym.getId() === 0) {
                // debugger
                sym.visible = true;
            }
            let targetY = 0;
                if (exploded) {
                    targetY = this.sendSymToPool(sym);
                } else {
                    targetY = this.calculateSymbolDrop(
                        sym,
                        index,
                        this.calculatePreviousExplodes(index, explodedItems),
                        this.calculatePreviousLocks(index, null, explodedItems),
                        false
                    );
                }
            let duration = this.calculateSymAnimDuration(sym, targetY, GameModel.gameConfig.symbolCascadeAnimTime);
            totalDuration += duration;
            if (duration) {
                // sym.setSpineAnim(sym.id, false);
                // sym.spineAnim.stop(true);
                // debugger
                this.cascadeTL.to(sym, duration, {
                    y: targetY,
                    ease: this.easingFunction,
                    onComplete: () => {

                        TweenMax.to(sym.scale, 0.05, {
                            y: 0.8,
                            onComplete: () => {
                                TweenMax.to(sym.scale, 0.05, {
                                    y: 1,
                                })
                            }
                        })
                        TweenMax.to(sym, 0.08, {

                            y: sym.y + (sym["powerOfBounce"] ? sym["powerOfBounce"] * 3 + 5 : 20),
                            onComplete: () => {
                                TweenMax.to(sym, 0.08, {

                                    y: sym.y - (sym["powerOfBounce"] ? sym["powerOfBounce"] * 3 + 5 : 20),
                                    onComplete: () => {
                                        // sym.spineAnim.play("floating_up");
                                        sym.playSpineAnim("land_chain");
                                        // sym.spineAnim.playChainingStates("land");
                                        // sym.hide();
                                    }
                                })
                            }
                        })
                    },
                    onCompleteScope: this
                },
                    "-=" + this.calculateSymAnimDuration(sym, targetY, GameModel.gameConfig.symCascadeTimeOffset));

            }
            index = this.getNextSymbolIndex(index);
        }

        if (totalDuration) {

            this.cascadeTL.restart();
        } else {
            this.onCompleteAnim();
        }

    }

    protected fillRemaining(hasAnticipation: boolean) {
        // debugger
        let exploded = this.symPool.length;
        this.inCascade = false;
        this.cascadeTL.pause();

        let count = (GameModel.gameConfig.symbolCount - this.symPool.length);
        let powerOfBounce = 8;
        if (exploded) {
            if (BBModel.hasAnticipation) {
                this.cascadeTL.to({}, BBModel.getAnticipationTimeDelay(), {});
            }

            while (this.symPool.length) {

                powerOfBounce--
                let targetY = this.getFillPosition();
                let sym = this.getNextFromPool() as BBReelSymbol;
                sym.setId(this.stopSymbols[count]);
                let duration = this.calculateSymAnimDuration(sym, targetY, GameModel.gameConfig.symbolCascadeAnimTime);
                if (BBModel.hasAnticipation && sym.id === 0) {
                    BBModel.stopIncrementAnticipationDelay = true;
                }

                sym.playSpineAnim();
                this.cascadeTL.to(sym, duration, {
                    onStart: () => {
                        sym.visible = true;
                    },
                    onComplete: () => {
                        if (this.isStopPlayingg == true) {
                            TweenMax.to(sym.scale, 0.05, {
                                y: 0.8,
                                onComplete: () => {
                                    TweenMax.to(sym.scale, 0.05, {
                                        y: 1,
                                    })
                                }
                            })
                            TweenMax.to(sym, 0.08, {

                                y: sym.y + (sym["powerOfBounce"] ? sym["powerOfBounce"] * 3 + 5 : 20),
                                onComplete: () => {
                                    TweenMax.to(sym, 0.08, {

                                        y: sym.y - (sym["powerOfBounce"] ? sym["powerOfBounce"] * 3 + 5 : 20),
                                        onComplete: () => {
                                            sym.playSpineAnim("land_chain");
                                            if (sym.id == 0 && BBModel.hasAnticipation) {
                                                BBAnimationsHelper.clearAnticipation();
                                            }
                                        }
                                    })
                                }
                            })
                        }
                        this.symCascadeComplete(hasAnticipation);
                    },
                    y: targetY,
                    ease: this.easingFunction,
                    onCompleteScope: this,
                },
                "-=" + this.calculateSymAnimDuration(sym, targetY, GameModel.gameConfig.symCascadeTimeOffset)
                );

                count++;
            }
            // this.reel.sortSymbolsByY();
            // ViewManager.getLayer(DefaultLayers.Reels).getCurrentScene().containers.get("reels").enableMask();
            this.cascadeTL.restart();
        } else {
            // debugger
            this.onStopCompleteAnim();
        }

    }

    protected mainDrop(hasAnticipation: boolean) {
        this.cascadeTL.pause();
        const numSyms: number = this.startSymbolIndex;;
        let symIdx = this.startSymbolIndex;
        let powerOfBounce = 8;
        while (symIdx >= 0 && symIdx < this.reel.symbols.length) {
            powerOfBounce--
            let sym = this.reel.symbols[symIdx] as BBReelSymbol;
            // if (sym.spineAnim) {
            //     sym.spineAnim.stop(true)
            // }
            sym["powerOfBounce"] = powerOfBounce
            let targetY = 0;
            if (this.isStopPlayingg === true) {
                let symId = this.stopSymbols[symIdx];
                // debugger
                sym.setId(symId);
                sym.playSpineAnim();
                sym.y = this.startSymbolsTweenPosition;
                targetY = this.symbolsDefaultPosition[symIdx];
            } else {
                targetY = this.endSymbolsTweenPosition;
            }

            this.cascadeTL.pause();
            if (symIdx != numSyms) {
                this.cascadeTL.to(sym, this.symbolAnimTime, {
                    y: targetY,
                    ease: this.easingFunction,
                    onComplete: () => {
                        if (this.isStopPlayingg == true) {
                            TweenMax.to(sym.scale, 0.05, {
                                y: 0.8,
                                onComplete: () => {
                                    TweenMax.to(sym.scale, 0.05, {
                                        y: 1,
                                    })
                                }
                            })
                            TweenMax.to(sym, 0.1, {

                                y: sym.y + (sym["powerOfBounce"] * 3 + 5),
                                onComplete: () => {
                                    TweenMax.to(sym, 0.1, {

                                        y: sym.y - (sym["powerOfBounce"] * 3 + 5),
                                        onComplete: () => {

                                            if (sym.id == 0 && SpinModel.isInFreespins()) {
                                                let reelGroup = ViewManager.getLayer(DefaultLayers.Reels)
                                                    .getCurrentScene()
                                                    .getSubView("ReelGroup") as BBReelGroup;
                                                reelGroup.wildEffect(sym, targetY)

                                            } else {
                                                sym.playSpineAnim("land_chain");
                                            }
                                        }
                                    })
                                }
                            })
                        }
                        this.symCascadeComplete(hasAnticipation);
                    },
                    onCompleteScope: this
                }, "-=" + GameModel.gameConfig.symCascadeTimeOffset);
            } else {
                this.cascadeTL.to(sym, this.symbolAnimTime, {
                    delay: this.animationStartDelay,
                    y: targetY,
                    ease: this.easingFunction,
                    onComplete: () => {
                        if (this.isStopPlayingg == true) {

                            TweenMax.to(sym.scale, 0.05, {
                                y: 0.8,
                                onComplete: () => {
                                    TweenMax.to(sym.scale, 0.05, {
                                        y: 1,
                                    })
                                }
                            })
                            TweenMax.to(sym, 0.1, {

                                y: sym.y + (sym["powerOfBounce"] * 3 + 5),
                                onComplete: () => {
                                    // debugger
                                    TweenMax.to(sym, 0.1, {

                                        y: sym.y - (sym["powerOfBounce"] * 3 + 5),
                                        onComplete: () => {
                                            if (sym.id == 0 && SpinModel.isInFreespins()) {
                                                let reelGroup = ViewManager.getLayer(DefaultLayers.Reels)
                                                    .getCurrentScene()
                                                    .getSubView("ReelGroup") as BBReelGroup;
                                                reelGroup.wildEffect(sym, targetY)
                                            } else {
                                                sym.playSpineAnim("land_chain");
                                            }
                                        }
                                    })
                                }
                            })
                        }
                        this.symCascadeComplete(hasAnticipation);
                    },
                    onCompleteScope: this
                },
                    hasAnticipation
                        ? "+=" + GameModel.gameConfig.anticipationDelay
                        : "-=" + GameModel.gameConfig.symCascadeTimeOffset
                );
            }
            symIdx = this.getNextSymbolIndex(symIdx);
        }
        // ViewManager.getLayer(DefaultLayers.Reels).getCurrentScene().containers.get("reels").enableMask();
        this.cascadeTL.restart();

    }

    public onStopCompleteAnim(hasWild?: boolean) {
        if (this.isStopPlayingg === true) {
            // ViewManager.getLayer(DefaultLayers.Reels).getCurrentScene().containers.get("reels").disableMask();
            this.isSpinning = false;
            this.cascadeTL.timeScale(1);
            this.setFinalSymbols();
            this.ts = 1;
            // GameModel.turboSpin = false;
            this.playLandingSound(hasWild);
            this.reel.emit(GameEvents.REEL_STOPPED, this.reel);
        }
    }

    protected playLandingSound(hasWild: boolean): void {
        // TODO: cache these
        const auds = [
            'balloon_land_1',
            'balloon_land_2',
            'balloon_land_3',
            'balloon_land_4',
            'balloon_land_5'
        ];

        const audioId = auds[Math.floor(Math.random() * auds.length)];

        SoundController.playSound(audioId);

        if (hasWild) {
            // SoundController.playSound('wild_turn', false);
        }
    }

    public spin(easingFunction: gsap.Ease = Power2.easeInOut) {
        // ConsoleUtil.log("CASCADE: SPIN", this.reel.reelIndex);
        this.easingFunction = easingFunction;
        this.reel.sortSymbolsByY();
        this.inCascade = false;
        this.killTimeline();
        this.cascadeTL = new TimelineMax({
            timeScale: 1,
            paused: true,
            onComplete: this.onCompleteAnim,
            onUpdate: () => this.spinUpdate(),
            onCompleteScope: this
        });
        this.isStopPlayingg = false;
        if (this.isSpinning === false) {
            this.isSpinning = true;
            this.cascadeTL.timeScale(1);
            this.primarySymbolsAnimationn(false);
        }
    }

    public stop(stopSymbolData: any[], hasAnticipation: boolean, hasWild = false) {
        // ConsoleUtil.log("CASCADE: STOP", this.reel.reelIndex, this.inCascade);
        if (!this.isStopPlayingg) {
            this.killTimeline();
            this.cascadeTL = new TimelineMax({
                paused: true,
                timeScale: 1,
                onComplete: () => {
                    this.onStopCompleteAnim(hasWild);
                },
                onUpdate: () => this.spinUpdate(),
                onCompleteScope: this
            });
            window["cascadeTl" + this.reel.reelIndex] = this.cascadeTL;
            this.isStopPlayingg = true;
            this.stopSymbols = stopSymbolData;
            this.secondaryCascadeAnimation(hasAnticipation);
            this.isSpinning = false;
        }

    }

    private primarySymbolsAnimationn(hasAnticipation: boolean) {

        const explodesMap = SpinModel.getCurrentCascadeExplodeMap();
        const explodedItems =
            explodesMap.length > 0 ? explodesMap[this.reel.reelIndex] : [];
        if (explodedItems && explodedItems.length) {
            const overlay = BBModel.getOverlays(OverlayType.Moving);
            let wildsMovedToReel = [];
            let wildsMovedFromReel = [];
            if (overlay.length > 0) {
                let fromVerb = BBModel.getMovedFromReelWilds(this.reel.reelIndex);
                let toVerb = BBModel.getMovedToReelWilds(this.reel.reelIndex);
                if (fromVerb.length > 0) {
                    wildsMovedFromReel = Array(App.config.numReels).fill(null);
                    fromVerb.forEach(row => {
                        wildsMovedFromReel[row] = 0
                    });
                }

                if (toVerb.length > 0) {
                    wildsMovedToReel = Array(App.config.numReels).fill(null);
                    toVerb.forEach(row => {
                        wildsMovedToReel[row] = 0
                    });

                }
            }
            TweenMax.delayedCall(this.fillRemainingDelay, () => {
                this.fillExplodes(explodedItems, wildsMovedToReel, wildsMovedFromReel);
            })
        } else {
            this.mainDrop(hasAnticipation);
        }

    }
}
